module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-drawer', {
    staticClass: "address-drawer",
    attrs: {
      "visible": _vm.internalVisible,
      "title": "地址管理",
      "size": "50%",
      "wrapperClosable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "address-container"
  }, [_c('div', {
    staticClass: "address-header"
  }, [_c('h3', {
    staticClass: "address-title"
  }, [_vm._v("客户收货地址")]), _vm._v(" "), _c('el-button', {
    staticClass: "add-btn",
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.toSave({})
      }
    }
  }, [_vm._v("\n        新增地址\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "address-list"
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    }
  }, [_vm._l((_vm.groupedAddresses), function(group, rowIndex) {
    return _c('div', {
      key: 'row_' + rowIndex,
      staticClass: "address-row"
    }, [_c('el-row', {
      attrs: {
        "gutter": 12,
        "type": "flex",
        "justify": "start"
      }
    }, [_vm._l((group), function(item) {
      return _c('el-col', {
        key: item.id,
        attrs: {
          "span": 12
        }
      }, [_c('div', {
        staticClass: "address-card",
        class: {
          'default-address': item.type === '常用'
        }
      }, [_c('div', {
        staticClass: "card-content"
      }, [_c('div', {
        staticClass: "address-icon"
      }, [_c('i', {
        staticClass: "el-icon-location-outline"
      })]), _vm._v(" "), _c('div', {
        staticClass: "address-info"
      }, [_c('div', {
        staticClass: "address-top"
      }, [_c('span', {
        staticClass: "contact-name"
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
        staticClass: "contact-phone"
      }, [_vm._v(_vm._s(item.telNum))]), _vm._v(" "), (item.type === '常用') ? _c('el-tag', {
        staticClass: "default-tag",
        attrs: {
          "size": "mini",
          "type": "primary"
        }
      }, [_vm._v("常用")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "address-region"
      }, [_vm._v("\n                      " + _vm._s(item.addressCode ? item.addressCode.join(' ') : '') + "\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "address-detail"
      }, [_vm._v("\n                      " + _vm._s(item.address) + "\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "address-footer"
      }, [_c('span', {
        staticClass: "operator"
      }, [_vm._v("创建人: " + _vm._s(item.operatorName || '系统'))]), _vm._v(" "), _c('span', {
        staticClass: "create-time"
      }, [_vm._v(_vm._s(item.createTime))])])]), _vm._v(" "), _c('div', {
        staticClass: "address-actions"
      }, [_c('el-button', {
        staticClass: "action-btn edit-btn",
        attrs: {
          "size": "mini",
          "type": "text",
          "icon": "el-icon-edit",
          "loading": _vm.loadingMap[("edit_" + (item.id))]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toSave(item)
          }
        }
      }, [_vm._v("\n                      编辑\n                    ")]), _vm._v(" "), _c('el-button', {
        staticClass: "action-btn delete-btn",
        attrs: {
          "size": "mini",
          "type": "text",
          "icon": "el-icon-delete",
          "loading": _vm.loadingMap[("delete_" + (item.id))]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toDelete(item)
          }
        }
      }, [_vm._v("\n                      删除\n                    ")]), _vm._v(" "), (item.type !== '常用') ? _c('el-button', {
        staticClass: "action-btn default-btn",
        attrs: {
          "size": "mini",
          "type": "text",
          "loading": _vm.loadingMap[("default_" + (item.id))]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.setDefault(item)
          }
        }
      }, [_vm._v("\n                      设为常用\n                    ")]) : _vm._e()], 1)])])])
    }), _vm._v(" "), (group.length === 1) ? _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "address-card address-card--placeholder"
    })]) : _vm._e()], 2)], 1)
  }), _vm._v(" "), (_vm.tableData.length === 0) ? _c('el-empty', {
    staticClass: "empty-address",
    attrs: {
      "description": "暂无收货地址"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.toSave({})
      }
    }
  }, [_vm._v("\n            添加第一个地址\n          ")])], 1) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('el-drawer', {
    staticClass: "edit-drawer",
    attrs: {
      "title": _vm.saveForm.id ? '编辑地址' : '新增地址',
      "visible": _vm.editDrawerVisible,
      "size": "40%",
      "wrapperClosable": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.editDrawerVisible = $event
      },
      "close": function($event) {
        _vm.editDrawerVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "edit-container"
  }, [_c('el-form', {
    ref: "saveForm",
    staticClass: "address-form",
    attrs: {
      "model": _vm.saveForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人姓名:",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入收货人姓名",
      "size": "small"
    },
    model: {
      value: (_vm.saveForm.name),
      callback: function($$v) {
        _vm.$set(_vm.saveForm, "name", $$v)
      },
      expression: "saveForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码:",
      "prop": "telNum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码",
      "size": "small",
      "maxlength": "11",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.saveForm.telNum),
      callback: function($$v) {
        _vm.$set(_vm.saveForm, "telNum", $$v)
      },
      expression: "saveForm.telNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在地区:",
      "prop": "addressCode"
    }
  }, [_c('cascader', {
    attrs: {
      "placeholder": "请选择省市区"
    },
    model: {
      value: (_vm.saveForm.addressCode),
      callback: function($$v) {
        _vm.$set(_vm.saveForm, "addressCode", $$v)
      },
      expression: "saveForm.addressCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址:",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入详细地址",
      "size": "small"
    },
    model: {
      value: (_vm.saveForm.address),
      callback: function($$v) {
        _vm.$set(_vm.saveForm, "address", $$v)
      },
      expression: "saveForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('el-button', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        _vm.editDrawerVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "save-btn",
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          保存地址\n        ")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-857cb936"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/customerMag/CustomerAddress.vue
// module id = 1026
// module chunks = 3